<template>
  <div class="login-page">
    <!-- style="width: 100vw; height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #C0C4CC;" -->
    <div class="logo-title">{{ title }}</div>
    <!-- style="font-size: 60px; color: white; margin-bottom: 20px;" -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="login-form">
      <!-- style="width: 300px;" -->
      <!-- <img src="../assets/images/logo.png" alt="" class="HH-logo"> -->
      <div class="HH-logo">
        <!-- <img src="../assets/images/greatfox.jpg" alt="" /> -->
        <img :src="imgSrc" alt="" />
      </div>
      <!-- <el-form-item prop="platform">
        <el-select
          v-model="ruleForm.platform"
          @change="(item) => {
            setPlatform(item)
          }"
          placeholder="请选择主体"
          style="width: 100%;">
          <el-option
            v-for="item in platformConf"
            :key="item.value"
            :label="item.label"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="username">
        <el-input
          v-model="ruleForm.username"
          autocomplete="off"
          placeholder="请输入帐号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm.password"
          placeholder="请输入密码"
          autocomplete="off"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          size="medium"
          style="width: 100%"
          @click="submitForm('ruleForm')"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import fetch from "@/assets/js/axios.js"; //导入axios.js文件
import { platformConf } from '@/assets/js/common'
export default {
  name: "login",
  components: {},
  data() {
    var validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("帐号不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      platformConf,
      ruleForm: {
        username: "",
        password: "",
        platform: null
      },
      rules: {
        username: [{ validator: validateUserName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["title"]),
    ...mapState(["imgSrc"]),
  },
  created() {
    this.ruleForm.username = localStorage.getItem("username");
    this.ruleForm.password = localStorage.getItem("password");
    if (sessionStorage.getItem("access_token")) {
      this.$router.push("/home/index")
    }
    this.selectMajorPlatform()
  },
  methods: {
    ...mapMutations(["setAdmin", "setPlatform", "setPlatformList"]),
    selectMajorPlatform () {
      const envConfig = {
        'ant': 'my',
        'bear': 'sx',
        'jb': 'jb',
        'lc': 'lc'
      }
      const platform = platformConf.find(item => item.value === envConfig[process.env.VUE_APP_ENV] || item.value === 'test')
      this.ruleForm.platform = platform
      this.setPlatform(platform)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 登录
          fetch({
            url: "/admin/authorizations/login",
            method: "POST",
            data: {
              username: this.ruleForm.username,
              password: this.ruleForm.password,
            },
          })
            .then((res) => {
              if (!res.data.status) {
                this.$message.error(res.data.message);
              } else {
                const { access_token, expired_at } = res.data.data
                sessionStorage.setItem(
                  "access_token",
                  access_token
                );
                sessionStorage.setItem(
                  "access_token_expired_at",
                  expired_at
                );
                localStorage.setItem("username", this.ruleForm.username);
                localStorage.setItem("password", this.ruleForm.password);
                fetch({
                  url: "/admin/admin/me",
                  method: "GET",
                  data: {},
                })
                  .then((res) => {
                    if (res.data.status) {
                      const user = {
                        ...this.ruleForm.platform,
                        ...res.data.data,
                        access_token,
                        access_token_expired_at: expired_at
                      }
                      this.setPlatformList(user)
                      // sessionStorage.setItem(
                      //   "admin",
                      //   JSON.stringify(res.data.data)
                      // );
                      // let admin = sessionStorage.getItem("admin");
                      // this.setAdmin(res.data.data);
                      let enter =
                        sessionStorage.getItem("lastRoute") || "/home/index";
                      this.$router.push(enter);
                    } else {
                      this.$message.error(res.data.message);
                    }
                  })
                  .catch((error) => {
                    this.$message.error(error);
                  });
              }
            })
            .catch((error) => {
              // this.$message.error(error)
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
.login-page {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #2f4050;
  overflow-y: auto;
  .logo-title {
    font-size: 60px;
    color: white;
    margin-bottom: 20px;
  }
  .login-form {
    width: 400px;
    padding: 10px 40px 15px 40px;
    margin: 60px auto;
    background: white;
    .HH-logo {
      position: relative;
      left: 50%;
      // top: 50%;
      width: 100px;
      height: 100px;
      margin-left: -50px;
      margin-top: -60px;
      margin-bottom: 10px;
      box-sizing: border-box;
      border-radius: 50%;
      border: 10px solid #fff;
      box-shadow: 0 1px 5px #ccc;
      background: #fff;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: contain;
        border: 1px solid #eee;
        box-sizing: border-box;
      }
    }
  }
}
</style>
